import React from 'react';
import { ContractHeader } from './ContractHeader';
import { InfoGrid } from './InfoGrid';
import { QuickActionsSidebar } from './QuickActionsSidebar';
import { ContractPages } from './ContractPages';
import { Contract } from '../../../types/contract';
import { entranceAnimations } from '../../../utils/animations';

interface ContractViewMainProps {
  contract: Contract;
  statusConfig: {
    label: string;
    color: string;
    bgColor: string;
    borderColor: string;
    icon: React.ComponentType<{ className?: string }>;
  };
  priorityInfo: {
    color: string;
    label: string;
  };
  urgencyAlert: {
    text: string;
    color: string;
  } | null;
  onEdit: () => void;
  onDelete: () => void;
  onContractUpdate: (updatedContract: Contract) => void;
  showContent?: boolean;
  onOpenPDFViewer: (page: number) => void;
  onMountBudget: () => void; // Nova prop para montar orçamento
}

export const ContractViewMain: React.FC<ContractViewMainProps> = ({
  contract,
  statusConfig,
  priorityInfo,
  urgencyAlert,
  onEdit,
  onDelete,
  onContractUpdate,
  showContent = false,
  onOpenPDFViewer,
  onMountBudget // Receber a nova prop
}) => {
  return (
    <div className="w-full mx-auto px-2 sm:px-4 lg:px-6 overflow-x-hidden">
      <div className="grid grid-cols-1 xl:grid-cols-12 gap-1 items-start">
        {/* Contract Info - 5 colunas */}
        <div className="xl:col-span-5 space-y-2 order-1 xl:order-1">
          {/* Contract Header com animação de entrada */}
          <div className={`${entranceAnimations.slideInFromLeft} animate-[slideInFromLeft2_0.5s_ease-out_forwards]`}>
            <ContractHeader
              contract={contract}
              statusConfig={statusConfig}
              priorityInfo={priorityInfo}
              urgencyAlert={urgencyAlert}
            />
          </div>

          {/* Grid de informações com animação de entrada */}
          <div className={`${entranceAnimations.slideInFromLeft} animate-[slideInFromLeft2_0.6s_ease-out_forwards]`}>
            <InfoGrid contract={contract} />
          </div>

        </div>

        {/* Sidebar - 3 colunas - Aparece em segundo no mobile */}
        <div className="xl:col-span-3 xl:space-y-2 space-y-1 order-2 xl:order-3">
          <div className={`${entranceAnimations.slideInFromRight} animate-[slideInFromRight2_0.7s_ease-out_forwards]`}>
            <QuickActionsSidebar
              contract={contract}
              statusConfig={statusConfig}
              priorityInfo={priorityInfo}
              onEdit={onEdit}
              onDelete={onDelete}
              showContent={showContent}
              onMountBudget={onMountBudget}
            />
          </div>
        </div>

        {/* Páginas do Contrato - 4 colunas - Aparece por último no mobile */}
        <div className="xl:col-span-4 space-y-2 overflow-x-hidden order-3 xl:order-2">
          <div className={`${entranceAnimations.scaleIn} animate-[zoomIn95_0.8s_ease-out_forwards]`}>
            <ContractPages contract={contract} onOpenPDFViewer={onOpenPDFViewer} />
          </div>
        </div>
      </div>
    </div>
  );
};
